import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { Pagination } from 'app/_models/pagination.model';
import { SiteForm } from 'app/_models/site-forms/site-form.model';
import { SiteFormsService } from 'app/_services/site-forms.service';
import { environment } from 'environments/environment';
import { SortEvent } from 'primeng/api';

@Component({
  selector: 'site-forms',
  templateUrl: './site-forms.component.html',
})
export class SiteFormsComponent implements OnInit {
  public routeRole: string;
  public tableData: SiteForm[]
  public columnOptionsSidebarVisible: boolean;

  public togglableColumns = [
    { displayName: 'Version', default: true },
    { displayName: 'Created Date', default: true },
    { displayName: 'Last Updated', default: true },
    { displayName: 'Sites', default: true },
  ];

  // table options
  public tableOptions = {
    visibleColumns: [],
  }

  // pagination
  public pageSizes: any = environment.pageSizes;
  public pagination: Pagination;
  @ViewChild('paginator', { static: true }) paginator;

  // Sorting and Filtering
  public defaultSortField = 'lastModifiedDate';
  public defaultSortOrder = -1;
  private sortOrderToText = (sortOrder: number) => { return sortOrder === 1 ? 'asc' : 'desc'; }
  public selectedSort = [this.defaultSortField + ',' + this.sortOrderToText(this.defaultSortOrder)];

  constructor(
    private siteFormService: SiteFormsService,
    private router: Router,
    globals: Globals,
  ) {
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
    this.setupColumnOptions();
    this.resetPagination(); // call service to populate table
  }

  public goToCreateForm() {
    this.router.navigate(['/', this.routeRole, 'site-forms', 'create']);
  }

  private fetchTableData() {
    this.siteFormService.getAllSiteForms(this.pagination, this.selectedSort, undefined).subscribe(response => {
      this.tableData = response.body;
      this.pagination.totalRecords = response.totalRecords;
    });
  }

  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.fetchTableData();
  }

  private resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
    this.goToFirstPage();
    this.fetchTableData();
  }

  public resetColumnOptions() {
    this.tableOptions = {
      visibleColumns: this.togglableColumns.filter(col => col.default).map(col => col.displayName),
    };

    this.saveTableOptions();
  }

  public saveTableOptions() {
    localStorage.setItem('ui.options.siteFormsTable', JSON.stringify(this.tableOptions));
  }

  private setupColumnOptions() {
    const savedOptions = localStorage.getItem('ui.options.siteFormsTable');

    if (savedOptions) {
      this.tableOptions = JSON.parse(savedOptions);
      this.togglableColumns
        .filter(col => col.default && !this.tableOptions.visibleColumns.includes(col.displayName))
        .forEach(col => this.tableOptions.visibleColumns.push(col.displayName));
      this.saveTableOptions();
    } else {
      this.resetColumnOptions();
    }
  }

  public customSort(sort: SortEvent) {
    const sortDirection = this.sortOrderToText(sort.order);

    this.selectedSort = [sort.field + ',' + sortDirection];

  this.goToFirstPage();

    this.fetchTableData();
  }

  private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }
}
